import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { CommonService } from '../../common-service';
import { environment } from '../../../../../environments/environment';
import { ReturnStruct } from '../../structs/return.struct';
import { SearchAutocompleteResponse } from '../../responses/platform/search-autocomplete.response';

@Injectable({
  providedIn: 'root',
})
export class SearchAutocompleteService extends CommonService {
  constructor(
    private router: Router,
    private httpClient: HttpClient
  ) {
    super();
  }

  public get(text: string): Observable<SearchAutocompleteResponse> {
    return this.httpClient
      .get<SearchAutocompleteResponse>(environment.urlApiPlatform + 'SearchAutocomplete?text=' + text)
      .pipe(catchError(this.handleError));
  }
}
